export default __webpack_public_path__ + "static/media/promocionAlarma4.5efc8879.png";